
export const useBackendUrl = () => {
    const backendUrl = useStrapiUrl()
    return backendUrl?.slice(0, -4)
}